var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BaseTags"},_vm._l((_vm.tags),function(tag,tagIndex){return _c('BaseTag',{key:tag + tagIndex,attrs:{"to":{
      name: 'search',
      query: {
        category: tag,
      },
    }}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }